import { useSiteConfig } from "./SiteConfigContext";

export function TenantContactDetails({ className }: { className?: string }) {
  const { contactEmail, contactPhone } = useSiteConfig();
  if (!contactEmail && !contactPhone) return null;

  return (
    <dl class={className}>
      {contactEmail && (
        <div>
          <dt>Email</dt>
          <dd>
            <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
          </dd>
        </div>
      )}
      {contactPhone && (
        <div>
          <dt>Phone</dt>
          <dd>
            <a href={`tel:${contactPhone.replace(/[^+\d]/g, "")}`}>{contactPhone}</a>
          </dd>
        </div>
      )}
    </dl>
  );
}
